import React, { useEffect, useRef, useState } from 'react'
import { getAlgoliaResults } from '@algolia/autocomplete-js'
import algoliasearch from 'algoliasearch'
import AutoComplete from './components/autoComplete'
import SearchListItem from './components/searchListItem'
import { trackEvent } from './withTracking'
import trackingEvents from './constants/trackingEvents'
import _ from 'lodash'

const { CATEGORY_SEARCH, ACTION_SEARCH_INPUT } = trackingEvents
const config = window.bidjs.config

let apiDetailsUrl = 'https://'
const isStaging = config.isStaging
if (isStaging) {
  apiDetailsUrl += `${process.env.REACT_APP_SEARCH_BRANCH || 'develop'}-`
}
apiDetailsUrl += 'search-listener.'
apiDetailsUrl += config.region === 'local' ? 'eu-west-2' : config.region
if (isStaging) {
  apiDetailsUrl += '.staging'
}
apiDetailsUrl += '.bidjs.com/apikey.json'

const getContentStringValue = (key, defaultValue) => {
  const customValue = window.bidjs.options && window.bidjs.options[key]
  if (customValue) {
    return (typeof customValue === 'string')
      ? customValue
      : customValue()
  }
  return defaultValue
}

const defaultLotDetailsUrl = '#!/auctions/%AUCTION_ID%/listings/%ITEM_ID%'
const lotDetailsUrl = window.bidjs.modules?.lotDetails || defaultLotDetailsUrl
const defaultMarketplaceLotDetailsUrl = '#!/marketplace/listings/%ITEM_ID%'
const marketplaceDetailsUrl = window.bidjs.modules?.marketplaceLotDetails || defaultMarketplaceLotDetailsUrl

const Search = () => {
  const [searchApi, setSearchApi] = useState({})
  const numberOfAttemptsRef = useRef(0)
  useEffect(() => {
    const fetchData = async () => {
      numberOfAttemptsRef.current += 1
      try {
        const res = await fetch(apiDetailsUrl)
        const apiData = await res.json()
        setSearchApi(apiData)
      } catch (e) {
        console.error(e)
      }
    }
    if (!searchApi.apiKey || !searchApi.appId) numberOfAttemptsRef.current === 0 ? fetchData() : _.debounce(fetchData, 30000)()
  }, [searchApi])
  if (!searchApi.apiKey || !searchApi.appId) return null
  const searchClient = algoliasearch(searchApi.appId, searchApi.apiKey)
  return (
    <div className="search-container">
      <AutoComplete
        openOnFocus={true}
        getSources={({ query }) => [
          {
            sourceId: 'products',
            getItems () {
              trackEvent(CATEGORY_SEARCH, ACTION_SEARCH_INPUT, query)
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    indexName: config.clientId,
                    query,
                    params: {
                      hitsPerPage: 30
                    }
                  }
                ]
              })
            },
            onSelect () {
              document.getElementById('autocomplete-0-input').blur()
            },
            templates: {
              item ({ item, components }) {
                return <SearchListItem hit={item} components={components} marketplaceUrl={marketplaceDetailsUrl} url={lotDetailsUrl} />
              },
              noResults ({ state }) {
                return getContentStringValue('searchResultsNone', 'No results found for "{0}"').replace('{0}', state.query)
              }
            }
          }
        ]}
        placeholder={getContentStringValue('searchPlaceholder', 'Search for Lots')}
      />
    </div>
  )
}

export default Search
